export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./createSubFamily.vue?vue&type=template&id=b7ca2920&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Supplies/Existence/createSubFamily.vue?vue&type=template&id=b7ca2920&scoped=true
// module id = 2135
// module chunks = 31